import React, { Component } from 'react';
import backgroundImage from '../../images/header/hero.png'

class HeroSection extends Component {

  render() {
    return (
      <section id="static-header">
        <div className="image-center-buffer">
            <img src={backgroundImage} alt="hero" />
        </div>
        <div className="hero-copy-section">
          <div className="container">
            <div className="row">
              <div className="col12">
                <h2>The Conversation <br />Starts With You.</h2>
                <h3>Be a Positive Influence</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default HeroSection;


// WEBPACK FOOTER //
// ./src/components/HeroSection/HeroSection.js